/* global axios */
import ApiClient from '../ApiClient';

class AiBotPromptPreviewAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/prompt_preview`, { accountScoped: true });
  }

  get({ message } = {}) {
    return axios.get(this.url, { params: { message } });
  }
}

export default AiBotPromptPreviewAPI;
